import API from '../libraries/API';

/**
 * Public parking eticket (shared link) — no auth.
 * @param {string} token - anonymous share token
 */
const eTicket = (_, token) => API.get(`parking-public/eticket/${token}`);

/**
 * Logged-in user's parking cards (MySCB portal). Asks for server-rendered QR
 * images so the web can render them with a plain <img>.
 */
const me = () => API.get('parking/me', { with_qr_image: true });

/**
 * Mark a parking access code as used (the web equivalent of the mobile
 * swipe-to-confirm, for non-BernExpo fields without a gate scanner).
 * @param {number} id - access_code_id
 */
const use = (id) => API.post(`parking/access/${id}/use`);

/**
 * Public swipe-to-confirm — mark a SHARED parking card used via its anonymous
 * share token (recipient has no login). Authorized by token possession.
 * @param {string} token - anonymous share token
 */
const usePublic = (token) => API.post(`parking-public/eticket/${token}/use`);

/**
 * Forward (share) a parking card to a recipient — issues a public share token
 * (and SMSes the link). Mirrors the app's "Weiterleiten".
 * @param {number} id - access_code_id
 * @param {{recipient_first_name?, recipient_last_name?, recipient_phone?, recipient_email?}} body
 */
const share = (id, body) => API.put(`parking/access/${id}/share`, body);

/**
 * Revoke a previously shared parking card (invalidates its public link).
 * @param {number} id - access_code_id
 */
const revokeShare = (id) => API.patch(`parking/access/${id}/revoke-share`);

/**
 * Staff QR scan (BernExpo) — mark a card used by its raw scanned code + the
 * shared access key. Gated by the key (no login).
 * @param {{code: string, key: string}} body
 */
const scan = (body) => API.post('parking-public/scan', body);

export default {
  eTicket,
  me,
  use,
  usePublic,
  share,
  revokeShare,
  scan,
};
